import "../App.css";
import headshot from "../images/headshot.jpg";
import HeroHeading from "./HeroHeading";

function AboutMeSection() {
  return (
    <header id="about" className="Row-layout">
      <img
        src={headshot}
        alt="Sofia Alvazzi"
        className="Headshot"
      />
      <div className="Column-layout">
        <HeroHeading/>
        <p className="About-text">I'm studying Computer Science & Quantitative Economics at Tufts University. 
          I'm passionate about building projects and systems that address real challenges 
          people and companies face. In my free time, I enjoy reading (especially memoirs), 
          skiing, and trying out new places to eat in Boston!</p>
      </div>
    </header>
  );
}

export default AboutMeSection;
